export function withIntroScreenReducer(state: boolean = false) {
  return state;
}
